import React, { Component } from 'react';
import $ from 'jquery';

import {
    ajax_wrapper,
    update_history,
    get_global_state,
    sort_objects,
} from 'functions';
import { NewProject, ProjectCard } from 'components';
import { Container, Loading, Button, Modal, Select } from 'library';

function focus_on_page() {
    setTimeout(function () {
        var x = window.scrollX,
            y = window.scrollY;
        $('.song-page-container').focus();
        window.scrollTo(x, y);
    }, 100);
}

export default class Projects extends Component {
    constructor(props) {
        super(props);

        let params = get_global_state()['params'];

        this.state = {
            loaded: false,
            projects: [],
            clients: [],
            show_client_filter: false,
            selected_client: params['client'] ? params['client'] : '',
            show_project_create: false,
            tagger: { name: '' },
            max_completed_projects: 11,
        };
    }

    componentDidMount() {
        this.refresh_projects();

        window.addEventListener('popstate', this.handle_history_change);
    }

    refresh_projects = (include_completed = false) => {
        ajax_wrapper(
            'GET',
            `/api/my_projects/${include_completed}/`,
            {},
            (value) => {
                let show_client_filter = value['clients'].length > 1;
                let selected_client = this.state.selected_client;

                if (value['clients'].length === 1) {
                    selected_client = value['clients'][0].id;
                }

                this.setState({
                    loaded: true,
                    projects: value['projects'],
                    clients: value['clients'],
                    selected_client: selected_client,
                    show_client_filter: show_client_filter,
                    tagger: value['tagger'],
                    admin: value['admin'],
                });
            },
        );
    };

    handle_history_change = (event) => {
        let params = get_global_state()['params'];

        if (params['client'] != this.state.selected_client) {
            this.setState({
                selected_client: params['client'],
            });
        }
    };

    render() {
        let projects = [];
        let completed_projects = [];

        let client_options = this.state.clients.map((client) => {
            return { text: client.name, value: client.id };
        });

        client_options = sort_objects(client_options, ['text']);

        let tagger_name = this.state.tagger['name'];
        let user = get_global_state()['user'];

        if (['owner', 'admin'].includes(user['role'])) {
            if (this.state.projects.length > 0) {
                // let new_project_button = (
                //     <div
                //         className="simple-card project-card flex-container"
                //         style={{ width: '80px' }}
                //     >
                //         <Button
                //             type="primary"
                //             onClick={() =>
                //                 this.setState({ show_project_create: true })
                //             }
                //             className="dark-button new-project-button"
                //         >
                //             +
                //         </Button>
                //     </div>
                // );
                // projects.push(new_project_button);
            }
        }

        let completed_projects_loaded = 0;

        for (let item of this.state.projects) {
            if (
                item.client == this.state.selected_client ||
                !this.state.selected_client
            ) {
                if (item.marked_complete) {
                    if (
                        completed_projects_loaded <=
                        this.state.max_completed_projects
                    ) {
                        completed_projects_loaded++;
                        completed_projects.push(
                            <ProjectCard
                                data={item}
                                tagger={this.state.tagger}
                            />,
                        );
                    }
                } else {
                    projects.push(
                        <ProjectCard data={item} tagger={this.state.tagger} />,
                    );
                }
            }
        }

        if (completed_projects_loaded === 0) {
            completed_projects.push(
                <Button
                    onClick={() => {
                        this.setState({ loaded: false });
                        this.refresh_projects(true);
                    }}
                >
                    Load Completed Projects
                </Button>,
            );
        } else {
            completed_projects.push(
                <Button
                    onClick={() =>
                        this.setState({
                            max_completed_projects:
                                this.state.max_completed_projects + 24,
                        })
                    }
                >
                    Load More
                </Button>,
            );
        }

        // TODO: change below card to not show for non-admins

        if (projects.length === 0) {
            let owner_options = null;
            if (['owner', 'admin'].includes(user['role'])) {
                owner_options = (
                    <div>
                        <i>{'—> Select from the following —> '}</i>
                        <br />
                        <br />
                        <Button
                            type="primary"
                            className="dark-button"
                            onClick={() =>
                                this.setState({ show_project_create: true })
                            }
                        >
                            Create a new project
                        </Button>
                        <br />
                    </div>
                );
            }
            projects.push(
                <div style={{ paddingBottom: '10px' }}>
                    <h3>You have no active projects!</h3>
                    {owner_options}
                </div>,
            );
        }

        let projects_jsx = [];

        let client_filter = !this.state.show_client_filter ? (
            ''
        ) : (
            <Select
                placeholder="Filter by Client"
                name="selected_client"
                className="transparent-select"
                style={{
                    display: 'inline-block',
                    verticalAlign: 'top',
                }}
                options={client_options}
                value={this.state.selected_client}
                set_form_state={function (state) {
                    this.setState(state);
                    update_history({}, `/?client=${state['selected_client']}`);
                }.bind(this)}
            />
        );

        if (user['role'] == 'tagger') {
            projects_jsx.push(
                <div id="tagger-projects">
                    <h1>Active Projects - {tagger_name}</h1>
                    <div className="simple-card-container row">{projects}</div>
                    <br />
                </div>,
            );
        } else {
            projects_jsx.push(
                <div>
                    <div
                        style={{
                            display: 'inline-block',
                            verticalAlign: 'center',
                        }}
                    >
                        <h1
                            style={{
                                display: 'inline-block',
                                verticalAlign: 'center',
                            }}
                        >
                            ALL PROJECTS
                        </h1>
                        {['owner', 'admin'].includes(user['role']) ? (
                            <a
                                onClick={() =>
                                    this.setState({ show_project_create: true })
                                }
                            >
                                <span className="new-project-button" />
                            </a>
                        ) : (
                            ''
                        )}
                    </div>
                    <div style={{ float: 'right' }}>{client_filter}</div>

                    <div className="simple-card-container row">{projects}</div>
                    <br />
                    <br />
                    <div
                        style={{
                            display: 'inline-block',
                            verticalAlign: 'center',
                        }}
                    >
                        <h1
                            style={{
                                display: 'inline-block',
                                verticalAlign: 'center',
                            }}
                        >
                            Completed Projects
                        </h1>
                    </div>

                    <div className="simple-card-container row">
                        {completed_projects}
                    </div>
                    <br />
                    <br />
                </div>,
            );
        }

        let new_project = null;
        if (this.state.show_project_create) {
            new_project = (
                <Modal
                    show={this.state.show_project_create}
                    on_hide={() =>
                        this.setState(
                            {
                                show_project_create: false,
                            },
                            focus_on_page,
                        )
                    }
                >
                    <div className=" modal-bounding-box">
                        <NewProject
                            selected_client={this.state.selected_client}
                        />
                    </div>
                </Modal>
            );
        }

        return (
            <Container>
                <Loading loaded={this.state.loaded}>
                    <div>
                        {new_project}
                        <div>{projects_jsx}</div>
                    </div>
                </Loading>
            </Container>
        );
    }
}
